import React from "react";

export default function Iframe({
    iframeRef,
    url
}) {
    return (
        <iframe
            ref={iframeRef}
            src={url}
            style={{
                width: "100%",
                height: "100%",
                border: "none"
            }}
        />
    );
}
